import { formatCurrency } from "../../../utils";
import { NumericInput } from "../types";
import { SettlementNetParams, SettlementNoteParams } from "./types";

export const centsOf = (value: NumericInput): number =>
  typeof value === "number" ? Math.round(value * 100) : 0;

// The server settles one transfer per command, net of its charge.
export const settlementNetCentsOf = ({
  amountCents,
  chargeCents,
  direction,
  cashbackCents = 0,
}: SettlementNetParams): number =>
  (direction === "IN" ? amountCents : -amountCents) -
  chargeCents +
  cashbackCents;

export const settlementNoteOf = ({
  accountName,
  netCents,
  isCashbackFunded = false,
}: SettlementNoteParams): string | null => {
  if (accountName === null) {
    return null;
  }
  if (netCents === 0) {
    return isCashbackFunded
      ? `Nothing will be taken from ${accountName}`
      : null;
  }
  const amount = formatCurrency(Math.abs(netCents) / 100);
  return netCents < 0
    ? `${amount} will be taken from ${accountName}`
    : `${amount} will be paid to ${accountName}`;
};
